import { Component, Vue } from 'vue-property-decorator';
import DefaultLayout from '@/components/Layouts/Default';
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';

@Component
export default class SignUpConfirm extends Vue {

  private mounted() {
    //@ts-ignore
    heap.track('game:signup:confirm')
  }
  
  private render(h: any) {

    const signInConfig = {
      usernameAttributes: 'username',
      confirmConfig: {
        code: this.$route.query.code,
        username: this.$store.getters.VERIFYNAME
      },
    }

    return (
      <DefaultLayout>
        <svg viewBox='0 0 977 977'>
          <use xlinkHref='#qp'></use>
        </svg>

        <amplify-confirm-sign-up confirmSignUpConfig={signInConfig.confirmConfig} usernameAttributes={signInConfig.usernameAttributes}></amplify-confirm-sign-up>
      </DefaultLayout>
    );
  }
}
